// Текущий пользователь и logout на SSO (team API). Отдельный axios-инстанс:
// глобальный настроен на посткалк-API (baseURL + Bearer), а team авторизует
// сессионной кукой на общем домене (.s25.dev / .s25.work) — нужен withCredentials.
import axios from 'axios'
import { authServiceUrlOrNull } from '@/auth/auth'

export interface AuthUser {
  name: string
  caption: string
  avatar: string
}

const http = axios.create({ withCredentials: true })

function authService(): string {
  const url = authServiceUrlOrNull()

  if (!url) {
    throw new Error('VUE_APP_AUTH_SERVICE is not configured')
  }

  return url
}

const AuthUserService = {
  me(): Promise<AuthUser> {
    return http.get(`${authService()}auth/me`).then(({ data }) => ({
      name: data.name || data.login || '',
      caption: (data.department && data.department.name) || data.login || '',
      avatar: data.avatarUrl || '',
    }))
  },

  logout(): Promise<void> {
    return http.post(`${authService()}auth/logout`).then(() => undefined)
  },
}

export default AuthUserService
